import { Api } from "../api";
import { AxiosResponse } from "axios";

/**
 * @typedef {{
 *  date: string,
 *  amount: number }} NextPayment
 */

/**
 * @typedef {{
 *  openingBalance: number,
 *  expenditures: number,
 *  transfers: number,
 *  closingBalance: number,
 *  nextPayment: NextPayment }} FileResponse
 */

const api = new Api("api/Municipalities");

/**
 * @param {number} municipalityId
 * @returns {Promise<AxiosResponse<FileResponse>>}
 */
export const getById = (municipalityId) =>
  api.get(`${municipalityId}/landing/financials`);
